#version 300 es
/*
* Preprocessed + Optimized from './default.vert'
* [Embedded string is compressed]
*/

uniform mediump vec4 uOutputFrame;
uniform mediump vec4 uOutputTexture;
uniform mediump vec4 uInputSize;

layout(location = 0) in mediump vec2 aPosition;
out mediump vec2 vTextureCoord;
out mediump vec2 vPosition;

void main()
{
    mediump vec2 _103 = (aPosition * uOutputFrame.zw) + uOutputFrame.xy;
    gl_Position = vec4((_103.x * (2.0 / uOutputTexture.x)) - 1.0, (_103.y * ((2.0 * uOutputTexture.z) / uOutputTexture.y)) - uOutputTexture.z, 0.0, 1.0);
    vTextureCoord = aPosition * (uOutputFrame.zw * uInputSize.zw);
    vPosition = aPosition;
}
